module.exports = __webpack_public_path__ + "6d400e03c8d8ecf1d7e4aee50be12765.fbx";